import { Dropdown as AntDropdown, DropdownProps } from 'antd'

const Dropdown = (props: DropdownProps) => {
    const { children, ...rest } = props
    return (
        <AntDropdown {...rest}>
            {/** Native HTML element needed for children: https://ant.design/components/tooltip#why-does-the-warning-finddomnode-is-deprecated-some-times-appear-in-strict-mode */}
            <div>{children}</div>
        </AntDropdown>
    )
}

export default Dropdown
